<template lang="pug">
.d-contents
  h2.text-none.text-h5.font-weight-bold.redesignBlack--text Дополнительная информация
  p.text-body-1.redesignBlack--text.mt-4
    | Для подачи заявки, укажите личные данные по каждой
    | {{ event.options.frontend_params.getEntityName('nominations_override', 2) }},
    | где это необходимо.
  v-sheet(
    rounded="xl"
    flat
  ).mt-8.pa-8
    api-form(
      v-model="formData"
      :method="(args) => method(args, uploadForms)"
      :observer-props="{ vid }"
      :fields="fields"
      no-reset
    )
      template(v-slot:save-btn="props")
        .d-flex.justify-center
          portal-target(
            :name="`${stepId}-actions`"
            :slot-props="props"
          )
</template>

<script>
import { USER_INPUT_TYPES_COMPONENTS } from '@/modules/Events/constants';
import ExpansionNominations from '../helpers/ExpansionNominations.vue';

const FIELD_KEYS = {
  attribute: 'attribute',
};

export default {
  props: {
    stepId: {
      type: [String, Number],
      required: true,
    },
    vid: {
      type: String,
      required: true,
    },
    event: {
      type: Object,
      required: true,
    },
    eventFields: {
      type: Array,
      required: true,
    },
    method: {
      type: Function,
      required: true,
    },
    nominations: {
      type: Array,
      required: true,
    },
    globalFields: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: this.value,
    };
  },
  computed: {
    nominationsIds() {
      return this.nominations.map(({ id }) => id);
    },
    attributesFields() {
      const { eventFields, nominationsIds, event } = this;
      const currentAttributes = eventFields
        .filter(({ isSystem }) => !isSystem)
        .filter((item) => nominationsIds.some((id) => item.isAssigned(event.id, id)) || item.isGlobal(event.id));
      return currentAttributes.map((field) => {
        // const fieldData = serverFields.find((i) => i.id === field.id);
        // const extraField = {
        //   ...USER_INPUT_TYPES_COMPONENTS[fieldData.type],
        //   ...fieldData,
        // };
        //
        const fieldData = USER_INPUT_TYPES_COMPONENTS[field.type];
        const attrs = fieldData.attrs({ ...field });
        return {
          // Нужно для валидации ошибок с сервера
          text: fieldData.title,
          pkey: `data.${field.id}.data`,
          value: `${FIELD_KEYS.attribute}|${field.id}`,
          rules: this.getRules({ required: fieldData.is_required }, fieldData.rules),
          component: fieldData.is,
          component_attrs: {
            ...attrs,
            'hide-details': false,
          },
        };
      });
    },
    fields() {
      const {
        // event,
        // nominations,
        // eventFields,
        attributesFields,
        globalFields,
      } = this;

      return [
        // {
        //   value: 'data',
        //   component: ExpansionNominations,
        //   component_attrs: {
        //     event,
        //     eventFields,
        //     nominations,
        //     class: 'mb-6',
        //   },
        // },
        ...attributesFields,
        ...globalFields,
      ];
    },
    hasRequiredItems() {
      return this.eventFields.some((i) => i.is_required);
    },
  },
  watch: {
    value(val) {
      this.formData = val;
    },
    formData(val) {
      this.$emit('input', val);
    },
  },
  methods: {
    async uploadForms(args) {
      // TODO: нужно изменить бэкенд на массовое сохранение (тогда этой хуйни не будет)
      // Этот код нужен, чтобы корректно сохранить порядок данных
      // для корректной установки ошибок с сервера
      // const data = Object.values(args.data.data)
      //   .flatMap((i) => Object.entries(i).reduce((acc, [key, value]) => {
      //     const [index, id] = key.split('.');
      //     acc[index] = {
      //       user_event_info_request_id: id,
      //       data: value,
      //     };
      //     return acc;
      //   }, []));

      // if (!data.length && !this.hasRequiredItems) {
      //   return new Promise((resolve) => resolve(true));
      // }

      // const payload = {
      //   ...args,
      //   data: { data },
      // };

      // return this.$rApi.user.massStore(payload);
      const data = args?.data || {};
      const attributes = this.getDataByType(data, FIELD_KEYS.attribute).map(({ id, value }) => ({ attribute_id: id, value }));
      await Promise.allSettled(attributes.map((item) => this.$models.event.attributesValues.create({ data: item })));
      return new Promise((resolve) => resolve(true));
    },
    getDataByType(data, type) {
      return Object.entries(data).map(([key, value]) => {
        const [itemType, itemId] = `${key}`.split('|');
        if (!itemType || !itemId || itemType !== type) return null;
        return {
          id: Number(itemId),
          value,
        };
      }).filter(Boolean);
    },
    getRules(params = {}, rules) {
      const { required } = params;
      const rulesList = [...(rules || '').split('|') || []];

      if (required) rulesList.push('required');

      return rulesList.filter(Boolean).join('|');
    },
  },
};
</script>
